import React from "react";
import sapImage from "../images/sap.png";

function Consent(props) {
  return (
    <div>
      <div>
        <img src={sapImage} height="30px" width="50px" alt="SAP logo"></img>
      </div>
      <p>
        <strong>
          Individual Video and Written Content Release Form (“Release”)
        </strong>
      </p>
      <p>
        The undersigned {props.name} (“You”) is participating in one or more of
        the activities noted below with SAP (hereinafter “SAP”) that will be
        publicly describing the use of SAP software products or services by an
        entity you are associated with,SAP (“Entry”)
      </p>
      <ul>
        <li>
          <strong>Written case study –</strong> A written case study describing
          the Entity’s experience with SAP and/or SAP’s products or services
        </li>
        <li>
          <strong>Video case study –</strong> A video case study describing the
          Entity’s experience with SAP and/or SAP’s products or Services
        </li>
        <li>
          <strong>Press release –</strong> A statement released to the press and
          media in order to make an announcement related to Entity’s experience
          with SAP and/or SAP’s products or services;
        </li>
        <li>
          <strong>Reference customer – </strong>Entails speaking at a SAP event
          about the Entity’s experience with SAP and/or SAP’s products or
          service; and
        </li>
        <li>
          <strong>Reference to other customers –</strong> Entails speaking with
          other SAP customers or potential customers regarding the Entity’s
          experience with SAP and/or SAP’s products or services
        </li>
      </ul>

      <p>
        SAP wishes to produce materials from these activities you are involved
        with in affiliation with the Entity, to promote its products and
        services (“Materials”). For this purpose, SAP may therefore use the
        Materials, and transfer them for respective use to its’ affiliated
        companies (a list of all SAP affiliates can be found under
        https://www.sap.com/dam/site/corporate/legal/sap-legal-entities.pdf,
        including Your name, likeness, photograph, voice, words, and any other
        information provided by You during the activities above (hereinafter
      </p>

      <p>
        altogether “Your Content”). SAP or its affiliates may use, reproduce,
        publish, broadcast and distribute Your Content in whole or in part,
        worldwide and in translated form on the SAP intranet and the worldwide
        web, on the SAP social media platforms and channels (such as Twitter,
        YouTube, Facebook, Instagram, LinkedIn), and in printed materials to
        promote SAP as a company, its brand, products and services. By signing
        this Release, You agree and consent that SAP may process Your Content
        that may include your personal data for the purposes described above.
      </p>
      <p>
        SAP will store and potentially use the Materials for a maximal period of
        [3] years, and delete Your Content thereafter. However, SAP is not under
        any obligation to pay you any royalties, nor has SAP the obligation to
        incorporate Your Content into the Materials.
      </p>
      <p>
        To the extent You reference the Entity, You represent that you are
        authorized to include such references as they appear in the Materials.
      </p>
      <p>
        You represent that you are at least 18 years of age and have the
        authority to enter into this Release and grant the rights granted herein
        (including, without limitation, use of the Your Content and Materials).
      </p>
      <p>
        You agree that all right, title, and interest in and to the Materials
        will be the property of SAP.
      </p>
      <p>
        You grant this consent freely and voluntarily and therefore retain the
        right to withdraw Your consent to this Release at any time through the
        submission of a written notice to SAP (mail to:
        customer.storytelling@sap.com). Upon a reasonable time following its
        receipt of such Release termination notice, SAP shall discontinue use of
        any part of Your Content subject to this Release and upon written
        request verify such discontinuation.
      </p>

      <p>
        To the extent, we transfer personal data within the global group of SAP
        companies You may refer to the privacy statement on
        https://www.sap.com/about/legal/privacy.html, if you want to learn more
        about how we legitimize cross-border transfers of personal data
        according to EU data protection legislation.
      </p>

      <p>
        Further, with regard to the information obligations as set forth in the
        European data protection legislation, you may also find further
        information on what data subject rights you have and how you may address
        them towards SAP, on https://www.sap.com/about/legal/privacy.html.
      </p>

      <p>
        Please note that if you want to enforce any of these rights in the
        context of this Release, please contact SAP by email to
        customer.storytelling@sap.com.
      </p>
    </div>
  );
}

export default Consent;
